import moment from "moment";
import { Tag } from "primereact/tag";
import DefaultList from "@Common/DefaultList";

const SortList = () => {
    return (
        <DefaultList
            dataKey={"promo_offers"}
            apiUrl="/promo/offers"
            titleName="Сортировка"
            titleAddButton='сортировку'
            keyFilterSearch='name'
            checkbox={false}
            columns={[
                { field: "index", header: "№", style: { width: "1%", maxWidth: "150px", pointerEvents: "none" }, sortable: true },
                {
                    field: "_id",
                    header: "ID",
                    style: { width: "10%", maxWidth: "103px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                },
                {
                    field: "title",
                    header: "Название",
                    style: { maxWidth: "350px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },

                {
                    field: "site.domain",
                    header: "Домен",
                    style: { maxWidth: "150px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
                {
                    body: (item) => <span>{moment(item.dateStart).format("DD.MM.YY")}</span>,
                    header: "Дата начала",
                    style: { width: "10%", maxWidth: "127px" },
                    sortable: false,
                },
                {
                    body: (item) => <span>{moment(item.dateEnd).format("DD.MM.YY")}</span>,
                    header: "Дата окончания",
                    style: { width: "10%", maxWidth: "127px" },
                    sortable: false,
                },

                {
                    body: (item) => <Tag severity={item.active ? "success" : "danger"} value={item.active ? "Активный" : "Не активный"}></Tag>,
                    header: "Статус",
                    style: { width: "1%" },
                    sortable: false,
                },
            ]}
            filterCreate={{
                show: true,
                inputs: [
                    {
                        blockName: "Фильтр",
                        inputs: {
                            _id: { label: "Id", type: "string", required: true, placeholder: "" },
                            title: { label: "Название оффера", type: "string", required: true, placeholder: "" },
                            active: {
                                label: "Активность?",
                                type: "select",
                                required: true,
                                options: [
                                    { value: "true", label: "true" },
                                    { value: "false", label: "false" },
                                ],
                                optionValue: "value",
                                optionLabel: "label",
                                selectedItemKey: "value",
                            },
                        },
                    },
                ],
            }}
        />
    );
};

export default SortList;
